
import { options, nextArrow, prevArrow } from '../global/slick-options';

jQuery( function( $ ) {
    document.querySelectorAll( '.slider--tiny' ).forEach( slider => {
        const slider_options = {
            ...options,
            slidesToShow: 6,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        };
        $( slider ).slick( slider_options );
    } );


    document.querySelectorAll( '.slider--small' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 4,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        } );
    } );


    document.querySelectorAll( '.slider--medium' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 3,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        } );
    } );


    document.querySelectorAll( '.slider--large' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 1,
            nextArrow,
            prevArrow,
        } );
    } );



    document.querySelectorAll( '.slider--huge' ).forEach( initHugeSlider );

    document.querySelectorAll( '.slider--staggered' ).forEach( slider => {
        jQuery( slider ).slick( {
            ...options,
            fade: true,
            slidesToShow: 1,
            dots: true,
            arrows: false,
        } );
    } );
} );

export function initHugeSlider( slider ) {
    jQuery( slider ).slick( {
        ...options,
        slidesToShow: 1,
        nextArrow,
        prevArrow,
    } );
}
